export default "__VITE_ASSET__06f3bdf5__"